import { Col, PageContent, PageHeader, Row } from '@/components';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { BatchSearchForm } from '../_components/BatchSearchForm';
import { BatchesTable } from '../_components/BatchesTable';

const BatchesPage: FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <PageHeader
        title={t('batch.page')}
        breadcrumbs={[{ title: t('batch.page') }]}
      />
      <PageContent>
        <Row>
          <Col span={24}>
            <BatchSearchForm />
          </Col>
          <Col span={24}>
            <BatchesTable />
          </Col>
        </Row>
      </PageContent>
    </>
  );
};

export default BatchesPage;
